import React from 'react';
import ColumnaBotoneraItem from '../ColumnaBotoneraItem.js';
import styles from '../CuadroListaEditable.module.css';
import styleCols from './TablaTorneoEtapas.module.css';

const TablaTorneoEtapas = (props) => {
  const lista = props.lista;
  const idElegido = props.idElegido;
  const onEditarItem = props.onEditarItem;
  const onEliminarItem = props.onEliminarItem;

  const esIdElegido = (idItem) => {
    return Number(idElegido) === Number(idItem);
  };

  return (
    <React.Fragment>
      <tr className={`${styles.titulos}`} key="0">
        <td className={`${styleCols.orden}`}>Ord</td>
        <td className={`${styleCols.etapa}`}>Etapa</td>
        <td className={`${styleCols.tipo}`}>Tipo</td>
        <td className={`${styles.editar}`}></td>
      </tr>
      {lista &&
        lista.map((item) => (
          <tr
            className={`${styles.valores} ${esIdElegido(item.id) && styles.elegido}`}
            key={item.id}
          >
            <td className={`${styleCols.orden}`}>{item.orden || ''}</td>
            <td className={`${styleCols.etapa}`}>{item.etapa?.descripcion || ''}</td>
            <td className={`${styleCols.tipo}`}>{item.definicion ? 'Definición' : 'Grupos'}</td>
            <ColumnaBotoneraItem
              idItem={item.id}
              onEditarItem={onEditarItem}
              onEliminarItem={onEliminarItem}
            />
          </tr>
        ))}
    </React.Fragment>
  );
};

export default TablaTorneoEtapas;
